import { render } from "./tishikuang.vue?vue&type=template&id=6b341d28"
import script from "./tishikuang.vue?vue&type=script&lang=js"
export * from "./tishikuang.vue?vue&type=script&lang=js"

import "./tishikuang.vue?vue&type=style&index=0&id=6b341d28&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__